import { object } from 'yup';

export const validationSchema = object().shape({
  selectedHome: object().shape({}).nullable().required('A selected home is required'),
}).nullable();
